import React from "react";
import PropTypes from "prop-types";

import { ChipContainer, TextContainer } from "./style";
import CloseIcon from "~/static/images/icons/close.svg";
import useViewport from "../../Helpers/hooks/useViewport";

const size = 24;

const Chip = (props) => {
    const viewport = useViewport();
    return (
        <ChipContainer
            viewport={viewport}
            selected={props.selected}
            onClick={() => {
                if (props.selected) props.onUnselect();
                else props.onSelect();
            }}
        >
            {props.icon ? (
                props.selected ? (
                    <img
                        src={CloseIcon}
                        style={{
                            height: size,
                            width: size,
                            transform: "scale(0.7)",
                        }}
                    />
                ) : (
                    <img
                        src={props.icon}
                        style={{ height: size, width: size }}
                    />
                )
            ) : null}
            <TextContainer selected={props.selected}>
                {props.value}
            </TextContainer>
        </ChipContainer>
    );
};

Chip.defaultProps = {
    selected: false,
    onSelect: () => {},
    onUnselect: () => {},
};

Chip.propTypes = {
    selected: PropTypes.bool,
    onSelect: PropTypes.func,
    onUnselect: PropTypes.func,
    value: PropTypes.string,
    icon: PropTypes.any,
};

export default Chip;
